import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  signal,
} from '@angular/core';
import QRCode from 'qrcode';

interface TrainingQRCodeProfile {
  EmployeeId?: string;
  employeeId?: string;
  EmployeeID?: string;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ups-training-qr-code',
  templateUrl: './training-qr-code.component.html',
  standalone: false,
})
export class TrainingQRCodeComponent implements OnInit, OnChanges {
  @Input() employeeId: string;
  @Input() profile: TrainingQRCodeProfile; // Can accept a profile object
  @Input() baseUrl = 'https://hse.universalplant.com/public/training-record';
  @Input() qrCodeSize = 200;
  @Input() showCard = true;
  @Input() cardTitle = 'Training Record QR Code';
  @Input() cardSubtitle = 'Scan to view employee training record';

  // Signals: both are written after an await, outside any template event of this component.
  readonly trainingQRCode = signal<string | undefined>(undefined);
  readonly isGeneratingQRCode = signal(false);

  ngOnInit() {
    this.generateTrainingQRCode();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      (changes['employeeId'] && !changes['employeeId'].firstChange) ||
      (changes['profile'] && !changes['profile'].firstChange)
    ) {
      this.generateTrainingQRCode();
    }
  }

  async generateTrainingQRCode() {
    console.log('[Training QR Code Component] Profile object:', this.profile);

    // Try to get employeeId from multiple sources
    const employeeId =
      this.employeeId ||
      this.profile?.EmployeeId ||
      this.profile?.employeeId ||
      this.profile?.EmployeeID;

    console.log('[Training QR Code Component] Employee ID:', employeeId);

    // Bug #30058: the profile hydrates its EmployeeID asynchronously (and mutates the
    // same object, so no ngOnChanges fires for the [profile] input). Encoding a missing
    // id here produced a permanent ".../training-record/undefined" QR. Wait for a real
    // id instead; the host binds [employeeId] as a primitive so its arrival re-fires
    // ngOnChanges and regenerates.
    if (!employeeId) {
      this.trainingQRCode.set(undefined);
      return;
    }

    const url = `${this.baseUrl}/${employeeId}`;
    console.log('[Training QR Code Component] Generated URL:', url);

    try {
      this.isGeneratingQRCode.set(true);
      this.trainingQRCode.set(
        await QRCode.toDataURL(url, {
          width: this.qrCodeSize,
          margin: 2,
          errorCorrectionLevel: 'M',
        })
      );
      console.log(
        '[Training QR Code Component] QR code generated successfully'
      );
    } catch (error) {
      console.error(
        '[Training QR Code Component] Error generating QR code:',
        error
      );
      this.trainingQRCode.set(undefined);
    } finally {
      this.isGeneratingQRCode.set(false);
    }
  }
}
